import React from 'react';
import { handleFileChange } from '../../../common/helper';


const DisputedPaymentView = (props) => {
  const RECOVERY_OPTION_RADIO = [{ name: "recovery_option", value: "full", label: "Full Recovery" }, { name: "recovery_option", value: "partial", label: "Partial Recovery" }];
  const handleRadioChange = (field_name, value) => {
    props?.setPayViaDisputeDetails(prev => ({
      ...prev,
      [field_name]: value
    }));
  }
  return (
    <div className="dispute-card-outer">
      <div className="card-title">
        <h3>Settle the outstanding disputed amount on this case ??</h3>
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={props?.isPaidViaRecoverySelected || props?.payViaDisputed || null}
            onChange={() => props?.setPayViaDisputed(!props?.payViaDisputed)}
            disabled={props?.disabledRecoveryCard || props?.isPayViaRecoveryInitiated || props?.isTranchRequested || props?.isPaidViaRecoverySelected}
          />
          <span className="slider"></span>
        </label>
      </div>
      {(!props?.isPaidViaRecoverySelected && !props?.payViaDisputed) ?
        <div className="acco-doc-list m-lg-t m-lg-b">
          <ul>
            <li>
              <div className='recovery-upload-text'>
                Upload Approval Proof
              </div>
              <div className='d-flex d-align-center'>
                <div className="more-file-upload doc-upload-btn ">
                  <input aria-label="img upload" type="file" name="" accept=".pdf,image/*"
                    disabled={props?.disabledRecoveryCard || props?.isPayViaRecoveryInitiated || props?.isTranchRequested || props?.isPaidViaRecoverySelected}
                    onChange={event => handleFileChange({ event, state: props?.payViaDisputeDetails, setState: props?.setPayViaDisputeDetails, key: "approval_doc_no_recovery", lead_id: 0, setIsLoading: props?.setIsLoading, is_array: false })}/>
                  <button aria-label="img upload btn" type="button" className={`btn-line ${props?.payViaDisputeDetails?.approval_doc_no_recovery ?`btn-line-upload`: ""}`}
                    // disabled={props?.disabledRecoveryCard || props?.isPayViaRecoveryInitiated || props?.isTranchRequested || props?.isPaidViaRecoverySelected}
                  >
                    {props?.payViaDisputeDetails?.approval_doc_no_recovery ? <><i className='ic-check upload-icn-check'></i> Uploaded</> : <><i className='ic-upload'></i>Upload</>}
                  </button>
                  
                </div>
                {!props?.disabledRecoveryCard && (!props?.isTranchRequested && !props?.isPaidViaRecoverySelected) && props?.payViaDisputeDetails?.approval_doc_no_recovery ?
                  <div className='m-sm-l icn-clear-upload'>
                    <i className='ic-clearclose' onClick={() => props?.setPayViaDisputeDetails(prev => ({ ...prev, approval_doc_no_recovery: "" }))}></i>
                  </div>
                  : <></>}
              </div>

            </li>
          </ul>
        </div> : <></>}
      {(props?.isPaidViaRecoverySelected || props?.payViaDisputed) ?
        <div className="card-recovery-section p-sm-t">
          <h3>Select Recovery Option</h3>
          <div className="recovery-radio-section radio-btn d-flex m-sm-t m-lg-b">
            {RECOVERY_OPTION_RADIO?.map((option, key) => (
              <div className="custom-control custom-checkbox m-md-r" key={option.value}>
                <input
                  aria-label={`for ${option.label}`}
                  type="radio"
                  className="custom-control-input"
                  name={option?.label}
                  value={option.value}
                  checked={props?.payViaDisputeDetails?.[option?.name] === option?.value}
                  onChange={()=>handleRadioChange(option?.name, option?.value)}
                  disabled={props?.disabledRecoveryCard || props?.isPayViaRecoveryInitiated || props?.isTranchRequested || props?.isPaidViaRecoverySelected}
                />
                <label htmlFor={option.id} className="custom-control-label">{option.label}</label>
              </div>
            ))}
          </div>
        </div>
        : <></>}
      <div className="card-content">
        {props?.disputeData?.map((item) => (
          <div className="card-list">
            <ul>
              <li className='total-dispute-txt'>
              <label>{item?.total || 0}</label>
              <span>{item?.label || ""}</span>
              </li>
              <li className='gmv-txt'>
              <label>PHP {(item?.gmv_recovery_amount && parseFloat(item?.gmv_recovery_amount).toFixed(2)) || 0}</label>
              <span>GMV Recovery Amount in Progress</span>
              </li>
              <li className='di-recovery-txt'>
              <label>PHP {(item?.di_recovery_amount && parseFloat(item?.di_recovery_amount).toFixed(2)) || 0}</label>
              <span>DI Recovery Amount in Progress</span>
              </li>
            </ul>
            
          </div>
        ))}
      </div>
    </div>
  );
};

export default DisputedPaymentView;
